module.exports = {
  language: 'Langue',
  selectLanguage: 'Sélectionner la langue',
  charging: 'En charge',
  notCharging: 'Pas en charge',
  advanceSetting: 'Paramètres avancés',
  chargingDesc: 'Commencer la charge quand le niveau de batterie est inférieur à ',
  enabled: 'Activé',
  disabled: 'Désactivé',
  onPowerRestore: 'Lors de la restauration de l\'alimentation',
  powerWakeDesc: '** Veuillez utiliser deux chargeurs USB indépendants pour charger le Pi et PiSugar respectivement, et garder l\'interrupteur d\'alimentation de PiSugar allumé. Il s\'allumera automatiquement lorsque l\'alimentation externe sera restaurée.',
  powerWakeDescFor3: 'PiSugar s\'allumera automatiquement lorsque l\'alimentation externe sera restaurée.',
  powerWakeOffWarning: 'Vous avez désactivé la fonction de réveil lors de la restauration de l\'alimentation, veuillez ne pas alimenter séparément le Raspberry Pi.',
  powerWakeOffTitle: 'Remarque',
  confirmButtonText: 'Confirmer',
  wakeUpFeature: 'Réveil programmé',
  repeat: 'Répéter',
  repeatEveryday: 'répéter tous les jours.',
  repeatOn: 'répéter le',
  checkAll: 'Tout sélectionner',
  clearAll: 'Tout effacer',
  wakeUpDesc: 'Programmer le réveil à',
  wakeUpOffDesc: 'Réveil programmé désactivé.',
  buttonFunction: 'Fonction bouton personnalisée',
  singleTapLabel: 'Appui simple',
  doubleTapLabel: 'Double appui',
  longTapLabel: 'Appui long',
  singleTap: 'appui simple',
  doubleTap: 'double appui',
  longTap: 'appui long',
  none: 'aucun',
  edit: 'Modifier',
  customShell: 'Shell personnalisé',
  shutdown: 'Arrêt',
  shellModalTitle: {
    single: 'Shell à exécuter pour l\'appui simple',
    double: 'Shell à exécuter pour le double appui',
    long: 'Shell à exécuter pour l\'appui long'
  },
  shell: 'Shell',
  shellPlaceholder: 'Saisir le script shell ici...',
  cancel: 'Annuler',
  confirm: 'Confirmer',
  triggered: 'Déclenché',
  safeShutdown: 'Arrêt sécurisé',
  batteryLevel: 'Niveau de batterie',
  immediately: 'Immédiatement',
  secondsDelay: 'secondes de délai',
  rtcTime: 'Heure RTC',
  sysTime: 'Heure système',
  syncTime: 'Synchroniser l\'heure',
  weekDay: {
    Monday: 'Lundi',
    Tuesday: 'Mardi',
    Wednesday: 'Mercredi',
    Thursday: 'Jeudi',
    Friday: 'Vendredi',
    Saturday: 'Samedi',
    Sunday: 'Dimanche'
  },
  weekDayShort: {
    Mon: 'Lun',
    Tue: 'Mar',
    Wed: 'Mer',
    Thu: 'Jeu',
    Fri: 'Ven',
    Sat: 'Sam',
    Sun: 'Dim'
  },
  batteryInputProtect: 'Protection d\'entrée de batterie',
  batteryInputProtectDesc: 'Le processus de charge s\'arrêtera lorsque 60% à 80% de la batterie sera atteint, ce qui peut efficacement prolonger la durée de vie de la batterie.',
  antiMistouch: 'Anti-manipulation accidentelle',
  antiMistouchDesc: 'Quand l\'anti-manipulation accidentelle est activée, l\'interrupteur doit être cliqué et maintenu pour se déclencher.',
  softPoweroff: 'Arrêt logiciel',
  softPoweroffDesc: 'Utiliser le bouton d\'interrupteur pour arrêter ne coupera pas directement l\'alimentation, la commande d\'arrêt sera émise par le logiciel.',
  softPoweroffShell: 'Shell d\'arrêt logiciel',
  softPoweroffShellDesc: 'Shell à exécuter quand l\'événement d\'arrêt logiciel est déclenché.',
  changeLoginPassword: 'Changer le mot de passe de connexion',
  username: 'Nom d\'utilisateur',
  password: 'Mot de passe',
  passwordConfirm: 'Veuillez saisir le mot de passe à nouveau',
  usernameCannotBeEmpty: 'Le nom d\'utilisateur ne peut pas être vide',
  passwordCannotBeEmpty: 'Le mot de passe ne peut pas être vide',
  passwordNotConsistent: 'Les deux mots de passe saisis doivent être identiques',
  usernameWithSpace: 'Le nom d\'utilisateur ne peut pas contenir d\'espaces',
  passwordWithSpace: 'Le mot de passe ne peut pas contenir d\'espaces',
  changePasswordSuccess: 'La modification est terminée.',
  loginDialog: 'Connexion',
  login: 'Se connecter'
}



// WEBPACK FOOTER //
// ./src/locale/fr-FR.js